import React, { Component } from "react";

import styled from "styled-components";
import { filterSoldDeals, filterClosedDeals } from '../dashboard.filters';
import { Divider } from "@material-ui/core";
import { DashboardBodyDefaultHeader } from "../DashboardBodyDefaultHeader";
import moment from 'moment';
import { DealTileGrid } from '@loanbossinc/component-library';

const StyledWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const StyledSoldGrid = styled(DealTileGrid)`
  && {
    display: flex;
    padding: 0;
    margin-top: .5em;
    margin-bottom: .5em;
    
    .active-img {
      opacity: 50%;
      &:hover {
        transition: opacity 0.5s;
        opacity: 1;
      }
    }
  }
`;

export class AssetImageGrid extends Component {
  mapTileProps = (items) => {
    if (!items) return [];

    return items.map(item => ({
      dealStage: item.stageId
      , dealStatus: item.dealStatusId
      , name: item.name
      , imgUrl: item.imageMedium
      , dealId: item.id
      , description: item.targetedClosing ? `TARGET CLOSE ${moment(item.targetedClosing).format('MM/DD/YYYY')}` : undefined
      , shared: item.shared
      , onClick: (dealId) => this.props.redirectToDealPage(dealId)
    }));
  }

  getSoldDeals = () => {
    const { items, searchText } = this.props;
    const filtered = filterSoldDeals(items, searchText);
    return this.mapTileProps(filtered);
  }

  getClosedDeals = () => {
    const { items, searchText } = this.props;
    const filtered = filterClosedDeals(items, searchText);
    return this.mapTileProps(filtered);
  }

  getSoldDealGrid = () => {
    const items = this.getSoldDeals();
    if (!items || !items.length) return null;

    return (
      <>
        <Divider style={{ marginTop: '1em', marginBottom: '1em' }} />
        <span>Sold Assets</span>
        <StyledSoldGrid items={items} history={this.props.history} />
      </>
    );
  }

  render() {
    const {
      title
      , onSearchChange
      , searchText
      , menuOptions
      , childDealsFilter
      , ...other
    } = this.props;

    return (
      <StyledWrapper>
        {childDealsFilter}
        <DashboardBodyDefaultHeader
          title={title}
          onSearchChange={onSearchChange}
          searchText={searchText}
          menuOptions={menuOptions}
        />

        <DealTileGrid {...other} items={this.getClosedDeals()} />

        {this.getSoldDealGrid()}

      </StyledWrapper>
    );
  }
}
